import noProducts from './no-products.svg';
import errorData from './error-data.svg';
import unavailable from './unavailable.svg';
import MoonRounded from "./Moon-Rounded.svg";

export const assets = {
  noProducts,
  errorData,
  unavailable,
  MoonRounded,
};